import {
    ISocialPlatformKey,
    SOCIAL_PLATFORMS,
} from "repoV2/utils/social/constants";
import { callApi } from "../../../../../utils/common/api/callApi";
import { GET_SALE_PAGE_DETAILS_API_URL } from "../sale.api.constants";
import { ISalePageSalePageBasicDataFromApi } from "./getSalePageBasicDataApi.interfaces";

export const callGetSalePageBasicDataApi = ({
    salePageUuid,
    subDomain,
}: {
    salePageUuid: string;
    subDomain: string;
}) =>
    callApi({
        url: `${GET_SALE_PAGE_DETAILS_API_URL}/${subDomain}/${salePageUuid}`,
        extraOptions: {
            appendAuthHeaders: true,
            appendExlyOriginHeaders: true,
            appendTimezoneHeaders: true,
        },
    }).then((response: any) => {
        const data = response?.data?.data || {};

        // tags: #test
        // console.log("here", JSON.stringify(data));

        const creatorDataInApi = data?.creator_details || {};
        const creatorSocialDataInApi = creatorDataInApi.social_info || {};
        const socialLinks: ISalePageSalePageBasicDataFromApi["aboutCreator"]["socialLinks"] =
            {} as ISalePageSalePageBasicDataFromApi["aboutCreator"]["socialLinks"];
        Object.keys(SOCIAL_PLATFORMS).forEach(i => {
            if (creatorSocialDataInApi[i]) {
                socialLinks[i as ISocialPlatformKey] =
                    creatorSocialDataInApi[i];
            }
        });

        const processedData: ISalePageSalePageBasicDataFromApi = {
            uuid: data.uuid,
            title: data.title,
            templateSlug: data.template_slug,
            listingUuid: data.listing_uuid,
            listingType: data.listing_type,
            listingTitle: data.listing_title,
            aboutCreator: {
                title: creatorDataInApi.title,
                name: creatorDataInApi.name,
                profileImgSrc: creatorDataInApi.profile_pic,
                shortDescription: creatorDataInApi.short_description,
                description: creatorDataInApi.description,
                socialLinks,
                followerCount: creatorSocialDataInApi.follower_count || {},
                creatorSiteFaviconImgSrc: creatorSocialDataInApi.favicon,
            },
            guranteeSection: {
                title: data.string,
                description: data.string,
                imgsrc: data.string,
                shortDescription: data.string,
            },
            seoPreview: {
                title: data.seo_preview?.title || data.listing_title,
                description: data?.seo_preview?.description || data.description,
                urlSlug: data.url_slug,
            },
            redirectUrl: data.redirect_url,
            metadata: { cdnUrl: data.metadata?.cdn_url },
        };
        return processedData;
    });
